goog.provide("shadow.js.shim.module$slate_react");
goog.provide("module$shadow_js_shim_module$slate_react");
shadow.js.shim.module$slate_react = shadow.js.nativeProvides["slate-react"] = shadow$bridge("slate-react");
module$shadow_js_shim_module$slate_react.default = shadow.js.shim.module$slate_react;
